module.exports = __webpack_public_path__ + "static/media/laMediatica-main.e49c1c1a.jpg";